import React from "react";
import { Crown, Snowflake } from "lucide-react";
import { hours, fullName } from "./shared";

export function SiteHoursTable({ salaries, responsableId, renderActions, emptyText = "Aucun salarié affecté à cet établissement." }) {
  return (
    <div className="bg-white border border-[#DEE2E6]" data-testid="site-hours-table">
      <div className="grid grid-cols-12 gap-3 px-4 py-2.5 text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] bg-[#F8F9FA] border-b border-[#DEE2E6]">
        <div className="col-span-4">Salarié</div>
        <div className="col-span-2">Poste</div>
        <div className="col-span-2">Contrat</div>
        <div className="col-span-2 text-right">Heures / mois</div>
        <div className="col-span-2 text-right">{renderActions ? "Actions" : "Statut"}</div>
      </div>
      {salaries.length === 0 ? (
        <div className="p-8 text-center text-sm text-[#868E96]" data-testid="site-hours-empty">{emptyText}</div>
      ) : salaries.map((s) => (
        <div key={s.id} data-testid={`site-salarie-${s.code}`}
             className="grid grid-cols-12 gap-3 px-4 py-3 items-center border-b border-[#F1F3F5] last:border-b-0 text-sm hover:bg-[#F8F9FA]">
          <div className="col-span-4 min-w-0">
            <div className="font-semibold flex items-center gap-2 truncate">
              {fullName(s)}
              {s.id === responsableId && (
                <span className="inline-flex items-center gap-1 text-[9px] uppercase tracking-wider font-bold bg-[#FFD700] text-[#0A0A0A] px-1.5 py-0.5" data-testid={`badge-responsable-${s.code}`}>
                  <Crown className="h-2.5 w-2.5" /> Responsable
                </span>
              )}
            </div>
            <div className="font-mono text-[11px] text-[#868E96]">{s.code}</div>
          </div>
          <div className="col-span-2 truncate text-[#495057]">{s.poste || "—"}</div>
          <div className="col-span-2 flex items-center gap-1.5 text-[#495057]">
            {s.saisonnier && <Snowflake className="h-3 w-3 text-[#0066FF]" title="Saisonnier" />}
            {s.contrat || "—"}
          </div>
          <div className="col-span-2 text-right font-mono font-bold">{hours(s.heures_mois)}</div>
          <div className="col-span-2 flex justify-end gap-1.5">
            {renderActions ? renderActions(s) : (
              <span className={`status-pill ${(s.status || "actif") === "actif" ? "status-active" : "status-inactive"}`}>
                {(s.status || "actif") === "actif" ? "Actif" : "Suspendu"}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
